import { LinkProps } from "react-router-dom";
import { TBadgeVariant } from "../Badge/types";

export interface ITab {
    title: string;
    path: string;
    disabled?: boolean;
    removeSearch?: boolean;
    badge?: string | number;
    badgeVariant?: TBadgeVariant;
    hide?: boolean;
    matchExact?: boolean;
}

export interface IBacklinkProps {
    trackName: string;
    title: string;
    url: string;
}

export interface ITopBarProps {
    sidebarButton: React.ReactNode;
    breadcrumbs?: React.ReactNode;
    settings?: React.ReactNode;
    actions?: React.ReactNode;
    search?: React.ReactNode;
    menu?: React.ReactNode;
    tabs?: ITab[];
    backlink?: IBacklinkProps;
    showMenu?: boolean;
    darkMode?: boolean;
    title?: string;
}

interface ITextBreadcrumb {
    to?: never;
}

export type TBreadcrumb = {
    title: string;
    isBeta?: boolean;
    icon?: React.ReactNode;
} & (LinkProps | ITextBreadcrumb);

export interface IBreadcrumbProps {
    breadcrumbs?: TBreadcrumb[];
}

export interface IPageProps {
    title: string;
    topBarHeight: string;
    topBar?: ITopBarProps;
    stretch?: boolean;
    padding?: string;
    children?: React.ReactNode;
}

export interface IFilterButtonProps {
    title?: string;
    selectedFiltersCount?: number;
    trackName: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}
